import {initializeApp} from "firebase/app";

const config = {
  apiKey: "AIzaSyCkm48wv50o8UMaC9CFc0qi0yaWaooh6qk",
  authDomain: "visitour-c3583.firebaseapp.com",
  databaseURL: "https://visitour-c3583.firebaseio.com",
  projectId: "visitour-c3583",
  storageBucket: "visitour-c3583.appspot.com",
  messagingSenderId: "240957243797",
  appId: "1:240957243797:web:f494cf258b64523d14f69c",
  measurementId: "G-506V8RS377"
};

export const initFirebase = initializeApp(config);
